export default {
  // START:: SET APP LOCALE
  setAppLocale(state, payload) {
    state.sakn_w_safar_admin_dashboard_language = payload;
  },
  // END:: SET APP LOCALE
};
